<template>
  <TableRegular
    :loading="loading"
    :rows="rows"
    :columns="columns"
    :sort="sort"
    :page="page"
    :per-page="perPage"
    :page-size="pageSize"
    :total-page="totalPage"
    :total-records="totalRecords"
    :line-numbers="lineNumbers"
    @onFilter="$emit('onFilter', $event)"
    @onPageChange="$emit('onPageChange', $event)"
    @onPerPageChange="$emit('onPerPageChange', $event)"
    @onSortChange="$emit('onSortChange', $event)"
  >
    <template slot="table-row" slot-scope="props">
      <template v-if="props.column.field === 'user'">
        <CustomerDetailsPopover :user="getUser(props.row)" :another-key="props.row.id" />
      </template>
      <template v-else-if="props.column.field === 'amount'">
        <LoanDetailsPopover
          v-if="props.row.loanId && props.row.loan"
          :loan="props.row.loan"
          :another-key="props.row.id"
        />
      </template>
      <p v-else-if="props.column.field === 'reminderDate'" class="whitespace-nowrap">
        {{ props.row.reminderDate }}
      </p>
      <p v-else-if="props.column.field === 'description'" class="text-left">
        {{ props.row.description }}
      </p>
    </template>
  </TableRegular>
</template>

<script>
import TableRegular from '@/components/ui/table/TableRegular';
import tableMixin from '@/mixins/tableMixin';
import CustomerDetailsPopover from '@/components/customer/CustomerDetailsPopover';
import LoanDetailsPopover from '@/components/loan/LoanDetailsPopover';

export default {
  mixins: [tableMixin],

  components: {
    TableRegular,
    CustomerDetailsPopover,
    LoanDetailsPopover,
  },

  methods: {
    getUser(note) {
      let result;
      if (note.loanId && note.loan?.user) {
        result = note.loan.user;
      }
      if (note.userId && note.user) {
        result = note.user;
      }
      return result;
    },
  },
};
</script>
